import { ActiveRecordingConflictModal } from "@/components/modal/active-recording-conflict";
import { AutoStopRecordingModal } from "@/components/modal/auto-stop-recording/auto-stop-recording-modal";
import { SystemAudioRecordingFailedModal } from "@/components/modal/system-audio-recording-failed";
import { MessageOverlay } from "@/components/overlay/message-overlay/message-overlay";
import { DebugInfoOverlay } from "@/components/error-handling/debug-info-overlay";
import { WelcomeOverlay } from "@/components/onboarding/welcome-overlay";
import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";
import { AUDIO_RECORDING_AUTO_STOP_LIMIT_DURATION } from "@/store/audio/recording/auto-stop";
import { StandardSyncErrorOverlay } from "@/components/error-handling/sync-error-overlay";
import { KeyboardShortcutsModal, useAppKeyboardShortcuts } from "@/modules/keyboard-shortcuts";

const AUTO_STOP_TITLE = "Recording stopped automatically";
const AUTO_STOP_MESSAGE = `This recording reached the maximum time limit (${AUDIO_RECORDING_AUTO_STOP_LIMIT_DURATION.toFormat(
  "h 'hours'"
)}) and was stopped.`;

interface AppOverlaysProps {}

export const StandardModeAppOverlays = observer<AppOverlaysProps>(() => {
  const { store } = useAppStore();

  useAppKeyboardShortcuts();

  return (
    <>
      <KeyboardShortcutsModal
        isOpen={store.interface.isKeyboardShortcutsModalOpen}
        onClose={store.interface.closeKeyboardShortcutsModal}
      />
      <ActiveRecordingConflictModal />
      <AutoStopRecordingModal
        isOpen={store.audio.ui.autoStopModalVisible}
        onClose={() => store.audio.ui.setAutoStopModalVisible(false)}
        title={AUTO_STOP_TITLE}
        message={AUTO_STOP_MESSAGE}
      />
      <SystemAudioRecordingFailedModal />
      <MessageOverlay />
      <StandardSyncErrorOverlay />
      <DebugInfoOverlay />
      <WelcomeOverlay />
    </>
  );
});
